// extracted by mini-css-extract-plugin
module.exports = {"box":"GameCircleVertical_box_mmMAY","list":"GameCircleVertical_list_2jhKZ","info":"GameCircleVertical_info_MP30t","description":"GameCircleVertical_description_2iWsR"};